import { render, staticRenderFns } from "./indexzx.vue?vue&type=template&id=d8305ec6&"
import script from "./indexzx.vue?vue&type=script&lang=js&"
export * from "./indexzx.vue?vue&type=script&lang=js&"
import style0 from "./indexzx.vue?vue&type=style&index=0&id=d8305ec6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports